var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 193,
    viewBox: "0 0 193 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.46 57.9805C149.712 57.2268 148.823 56.6285 147.843 56.2203C146.863 55.812 145.812 55.6018 144.75 55.6018C143.688 55.6018 142.637 55.812 141.657 56.2203C140.677 56.6285 139.788 57.2268 139.04 57.9805L79.1299 117.971L53.9595 92.7205C53.1833 91.9707 52.2671 91.3812 51.263 90.9855C50.259 90.5898 49.1868 90.3957 48.1078 90.4144C47.0287 90.4331 45.964 90.6641 44.9742 91.0943C43.9844 91.5244 43.0891 92.1454 42.3393 92.9216C41.5895 93.6978 41 94.614 40.6043 95.6181C40.2086 96.6221 40.0145 97.6943 40.0332 98.7733C40.0519 99.8523 40.2829 100.917 40.7131 101.907C41.1433 102.897 41.7642 103.792 42.5404 104.542L73.4204 135.422C74.1679 136.175 75.0574 136.774 76.0373 137.182C77.0173 137.59 78.0684 137.8 79.1299 137.8C80.1915 137.8 81.2426 137.59 82.2226 137.182C83.2025 136.774 84.092 136.175 84.8395 135.422L150.46 69.8018C151.276 69.0487 151.927 68.1348 152.373 67.1175C152.818 66.1002 153.048 65.0017 153.048 63.8911C153.048 62.7806 152.818 61.682 152.373 60.6648C151.927 59.6475 151.276 58.7336 150.46 57.9805Z",
    fill: "#AB54A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4b88068be2aa0a6c651de683d16761bb.svg";
export { ForwardRef as ReactComponent };